import './instrument';
import * as Sentry from '@sentry/react';
import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './globals.ts';
import "./index.css";
import "./globals.css";
import { RouterProvider } from 'react-router-dom';
import { topLevelRouter } from './routing/router.tsx';
import AuthPageWrapper from './routing/auth_page_wrapper.tsx';
import { AuthService } from './services/auth/auth_service.ts';
import { AntdThemeProvider } from './providers/antd_theme_provider.tsx';
import { BackgroundProvider } from './providers/background_provider.tsx';
import LoaderComponent from 'shared-lib/components/loader.js';
import { ErrorRenderer } from 'shared-lib';
import { ErrorBoundary } from "react-error-boundary";

AuthService.getInstance(); // initialize singleton
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AntdThemeProvider>
        <BackgroundProvider>
          <ErrorBoundary
            fallback={<ErrorRenderer />}
            onError={(error, info) =>
              Sentry.captureException(error, {
                extra: { componentStack: info.componentStack },
              })
            }
          >
            <Suspense fallback={<LoaderComponent />}>
              <AuthPageWrapper>
                <RouterProvider router={topLevelRouter} />
              </AuthPageWrapper>
            </Suspense>
          </ErrorBoundary>
        </BackgroundProvider>
      </AntdThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
